import { usePAChecklistFollowUp } from '../pa_checklist_followup_context';
import styles from '../pa_checklist_followup.module.scss'
import Tabela from '../../../Misc/Tabela/Tabela';
import { capitalizeFirstChar } from '../../../../utils/misc_utils';

const PAChecklistFollowUpMedTab = () => {
  const { itemSelecionado } = usePAChecklistFollowUp();

  const medColumns = [
    { name: 'Parte', selector: row => row.descricao_parte, width: '20%' },
    { name: 'Grade', selector: row => row.descricao_grade },
    { name: 'FT', selector: row => row.medicao_ft },
    { name: 'Piloto', selector: row => row.piloto },
    { name: 'Tolerância', selector: row => row.tolerancia },
    { name: 'A. Obrigatória', selector: row => row.amostra_obrigatoria },
    { name: 'A. Opcional', selector: row => row.amostra_opcional || '-' },
    { name: 'Aceitável?', selector: row => row.medida_aceitavel ? 'Sim' : 'Não' },
  ];

  const medidaAtelierColumns = itemSelecionado.resMedidasAtelier[0] ? Object.keys(itemSelecionado.resMedidasAtelier[0]).map((key, index) => ({
    name: capitalizeFirstChar(key),
    selector: row => row[key] || '-',
    width: index === 1 ? '200px' : undefined
  })) : [
    { name: 'Medida', selector: row => '' },
    { name: 'Tamanho', selector: row => '' },
    { name: 'Tolerância', selector: row => '' }
  ];

  return (
    <section className={styles.inner_tab_wrapper}>
      {
        itemSelecionado.url_desenho_tecnico &&
        <div style={{ display: 'flex' }}>
          <div style={{ width: '38px' }} />
          <img src={itemSelecionado.url_desenho_tecnico} width={'50%'} style={{ margin: 'auto' }} />
        </div>
      }
      {
        itemSelecionado.resMedidasAtelier.length > 0 &&
        <section className={styles.grade_conferencia}>
          <label className={styles.form_label}>Medidas Ficha Técnica - Atelier (somente conferência)</label>
          <Tabela
            columns={medidaAtelierColumns}
            data={itemSelecionado.resMedidasAtelier}
            pagination={false}
          />
        </section>
      }
      {
        !itemSelecionado.url_desenho_tecnico && itemSelecionado.dev_interno &&
        <div className={styles.warn_text}>Não há desenho técnico disponível para esse produto</div>
      }
      {
        itemSelecionado.analiseMedidas.length === 0 &&
        <div className={styles.no_data_message}>Não há medidas inseridas</div>
      }
      {
        itemSelecionado.analiseMedidas.length > 0 &&
        <section className={styles.grade_conferencia}>
          <label className={styles.form_label}>Medidas Inseridas (Etapa de Análise)</label>
          <Tabela
            columns={medColumns}
            data={itemSelecionado.analiseMedidas}
            pagination={false}
            highlightOnHover={true}
          />
        </section>
      }
    </section>
  );
}

export default PAChecklistFollowUpMedTab;
